export const billingAmmounts = [
    { value: 100, title: 100 },
    { value: 200, title: 200 },
    { value: 300, title: 300 },
    { value: 400, title: 400 },
    { value: 500, title: 500 },
    { value: 1000, title: 1000 },
];